export default __webpack_public_path__ + "static/media/wave.a0113a4e.png";